module.exports = __webpack_public_path__ + "static/media/m1_sf_2.a859ba24.png";